import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../hooks/useApi";
import { ManagerDataProps } from "../../../../pages/Manage/ManageAuth";
import { Textarea } from "../../../Input/Textarea";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { DeleteModalLabel } from "../../Users/UserDetail/CommentModal/CommentDeleteModal";

interface ManagerDeleteModalProps {
  closeEvent: () => void;
  managerData: ManagerDataProps;
  updateEvent: () => void;
}

export default function ManagerDeleteModal({
  closeEvent,
  managerData,
  updateEvent,
}: ManagerDeleteModalProps) {
  const [deleteBtnClick, setDeleteBtnClick] = useState(false);
  const [reason, setReason] = useState("");

  const { response } = useApi({
    method: "delete",
    url: deleteBtnClick ? `admin/${managerData?.id}` : undefined,
    data: {
      reason,
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      closeEvent();
      updateEvent();
      toast.success("관리자가 삭제되었습니다.", {});
    }
  }, [closeEvent, response, updateEvent]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="관리자 삭제"
        isDeleteModal={true}
        isSmallModal={true}
        closeEvent={() => closeEvent()}
        confirmEvent={() => setDeleteBtnClick(true)}
        confirmDisabled={reason === ""}
      >
        <DeleteModalLabel>삭제 사유</DeleteModalLabel>

        <Textarea
          placeholder="삭제 사유 입력(100글자 이내)"
          onChange={(e) => setReason(e.target.value)}
          value={reason}
        />
      </DefaultModalLayout>
    </>
  );
}
